import { CircularProgress, Box } from '@mui/material';

const MultiColorCircularLoader = ({ height }: { height: string }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height,
      }}
    >
      <CircularProgress thickness={5} color="secondary" />
    </Box>
  );
};

export default MultiColorCircularLoader;
